export default __webpack_public_path__ + "static/media/start-campaign.234f1c04.svg";